import {
    MATERIAL_SUMMARY_ACTIVITY,
    resolveMaterialSummaryRecordCount,
} from '../constants/material-summary.constants';
import type {
    MaterialSummaryPayload,
    MaterialSummaryReportFilter,
} from '../models/material-summary.model';

export interface MaterialSummaryTaskPaneFilterRead {
    readonly recordType?: string;
    readonly recordCount: number;
    readonly date?: string;
    readonly fromDate?: string;
    readonly toDate?: string;
    readonly originFacilityCode?: string;
    readonly destinationFacilityCode?: string;
    readonly materialTypeName?: string;
    readonly inputMaterialTypeId?: string;
    readonly reportAlias?: string;
}

/**
 * Builds {@link MaterialSummaryReportFilter} from task-pane read shape (trimmed strings, omitted empties).
 */
export function buildMaterialSummaryFilterFromTaskPaneRead(
    read: MaterialSummaryTaskPaneFilterRead
): MaterialSummaryReportFilter {
    const recordCount = resolveMaterialSummaryRecordCount(read.recordCount);
    const filter: MaterialSummaryReportFilter = {
        recordCount,
    };

    const rt = read.recordType?.trim();
    if (rt) {
        filter.recordType = rt;
    }

    const single = read.date?.trim();
    const from = read.fromDate?.trim();
    const to = read.toDate?.trim();

    if (single) {
        filter.date = single;
    } else if (from && to) {
        filter.fromDate = from;
        filter.toDate = to;
    }

    if (read.originFacilityCode?.trim()) {
        filter.originFacilityCode = read.originFacilityCode.trim();
    }
    if (read.destinationFacilityCode?.trim()) {
        filter.destinationFacilityCode = read.destinationFacilityCode.trim();
    }
    if (read.materialTypeName?.trim()) {
        filter.materialTypeName = read.materialTypeName.trim();
    }
    if (read.inputMaterialTypeId?.trim()) {
        filter.inputMaterialTypeId = read.inputMaterialTypeId.trim();
    }
    if (read.reportAlias?.trim()) {
        filter.reportAlias = read.reportAlias.trim();
    }

    return filter;
}

export function buildMaterialSummaryPayloadFromFilter(
    filter: MaterialSummaryReportFilter
): MaterialSummaryPayload {
    return {
        activity: MATERIAL_SUMMARY_ACTIVITY,
        isAsync: false,
        data: { filter },
    };
}
